import React from "react";
import { Navigation } from "lucide-react";
import { toast } from "sonner";
import { isLatLng } from "@/components/maps/geo";

export const directionsLink = (lat, lng) => (isLatLng(lat, lng) ? `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}` : "");

// Opens WhatsApp with a prepared message (user picks the contact and reviews it before sending).
export default function DirectionsShareButton({ shopName, url, className = "", testid = "directions-share-btn", missingText = "Is shop ki map location abhi set nahi hai." }) {
  const share = () => {
    if (!url) { toast.info(missingText); return; }
    const msg = `${shopName || "Shop"} tak pahunchne ke liye Google Maps directions:\n${url}\n\n— VerB`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  };
  return (
    <button type="button" onClick={share} aria-disabled={!url} className={`inline-flex items-center gap-1.5 rounded-full border px-4 py-2 min-h-[40px] text-sm font-semibold transition-colors ${url ? "border-emerald-200 text-emerald-800 bg-white hover:bg-emerald-50" : "border-slate-200 text-slate-400 bg-white"} ${className}`} data-testid={testid}>
      <Navigation className="w-4 h-4" /> Directions WhatsApp
    </button>
  );
}
